<template>
  <b-row>
    <b-col cols="12">
      <karma-request-edit-form />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import KarmaRequestEditForm from './KarmaRequestEditForm.vue'

export default {
  components: {
    BRow,
    BCol,
    KarmaRequestEditForm,
  },
}
</script>

<style lang="scss">
    @import '@core/scss/vue/libs/vue-wizard.scss';
    @import '@core/scss/vue/libs/vue-select.scss';
</style>
